import React from 'react';

interface Props {
  suggestions: {id: number, name: string, text: string}[];
  onSelect: (s: {name: string, text: string}) => void;
  onClose: () => void;
}

export default function ShortcutSuggestions({ suggestions, onSelect, onClose }: Props) {
  if (suggestions.length === 0) return null;
  return (
    <div style={{
      position: 'absolute', zIndex: 1000, background: '#fff',
      border: '1px solid #d1d5db', borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      minWidth: 280, maxWidth: 400, maxHeight: 200, overflowY: 'auto', bottom: '100%', left: 0, marginBottom: 4
    }}>
      <div style={{ padding: '6px 10px', fontSize: 11, color: '#9ca3af', borderBottom: '1px solid #f3f4f6' }}>
        Skróty — kliknij aby wstawić, Esc aby zamknąć
      </div>
      {suggestions.map(s => (
        <div key={s.id} onClick={() => onSelect(s)}
          style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f9fafb' }}
          onMouseEnter={e => (e.currentTarget.style.background = '#eff6ff')}
          onMouseLeave={e => (e.currentTarget.style.background = '#fff')}>
          <div style={{ fontWeight: 600, fontSize: 13, color: '#1d4ed8' }}>#{s.name}</div>
          <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{s.text}</div>
        </div>
      ))}
    </div>
  );
}
